import { Route, Routes } from 'react-router-dom'
import HealthReportPage from './Page'

export default function HealthReportIndex() {
  return (
    <Routes>
      <Route path="/" element={<HealthReportPage />} />
    </Routes>
  )
}
